<template>
  <div v-if="project && project.attributes">
    <v-speed-dial v-show="permit.canCreateBoard(project) || permit.canCreateTicket(project)"
      v-model="fab"
      :bottom="true"
      :right="true"
      direction="top"
      :open-on-hover="true"
      transition='slide-y-reverse-transition'
      fixed
      >
      <v-btn
        slot="activator"
        v-model="fab"
        color="#0155a8"
        dark
        fab
        fixed
        >
        <v-icon>add</v-icon>
        <v-icon>close</v-icon>
      </v-btn>

      <v-tooltip bottom color="#fff" v-if="permit.canCreateTicket(project)">
        <v-btn fab
          color="#3a9cfc"
          small
          slot="activator"
          @click="newTicket = !newTicket"
        >
          <v-icon small color="white">local_activity</v-icon>
        </v-btn>
        <span class="black--text">Create new ticket</span>
      </v-tooltip>

      <v-tooltip bottom color="#fff" v-if="permit.canCreateBoard(project)">
        <v-btn fab
          color="#0155a8"
          small
          slot="activator"
          @click="newBoard = !newBoard"
        >
          <v-icon small color="white">view_carousel</v-icon>
        </v-btn>
        <span class="black--text">Create new board</span>
      </v-tooltip>
    </v-speed-dial>

    <v-card class="mb-3 sticky-element" :class="stickyClass">
      <v-layout row wrap justify-space-between >
        <v-flex xs12 sm6 class="pa-2">
          <v-layout row wrap>
            <v-flex shrink class="text-xs-center mr-3">
              <v-avatar size=48 >
                <img :src="logoThumbUrl" alt="Avatar" v-if="logoThumbUrl">
                <v-icon color="primary" large v-else>ballot</v-icon>
              </v-avatar>
            </v-flex>
            <v-flex shrink class="grey--text" >
              <h1 class="grey--text text--darken-2">
                {{project.attributes.name}}
              </h1>
              <h3>{{project.attributes.description}}</h3>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-card>

    <v-progress-linear :indeterminate="true" v-show="loading"></v-progress-linear>

    <v-dialog
      :fullscreen="$vuetify.breakpoint.xsOnly"
      v-model="newBoard"
      max-width="500px"
      persistent
      >
      <boardNew :project="project"></boardNew>
    </v-dialog>

    <v-dialog
      v-if="project && (statuses.length > 0) && (members.length > 0)"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      v-model="newTicket"
      max-width="65%"
      persistent
      >
      <ticketNew :project="project" :boards="boards" :statuses="statuses" :members="members"></ticketNew>
    </v-dialog>

    <v-layout row wrap mb-4>
      <v-flex>
        <!-- master list just doesn't have an actual board, so we need to pass the project in instead -->
        <board :project="project" :projectBoards="boards" :projectStatuses="statuses" :projectMembers="members" :backlog="false"></board>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { EventBus } from '@/utilities/event-bus'
  import permissions from '@/utilities/permissions'

  import projectService from '@/services/project'
  import projectBoard from '@/components/project/_board'

  import ticketNew from '@/components/ticket/_new'

  import boardService from '@/services/board'
  import boardNew from '@/components/board/_new'

  import statusService from '@/services/status'
  import memberService from '@/services/member'

  export default {
    name: 'project-show',

    components: {
      board: projectBoard,
      ticketNew: ticketNew,
      boardNew: boardNew
    },

    props: ['id'],

    data () {
      return {
        permit: permissions,
        newBoard: false,
        newTicket: false,
        project: null,
        boards: [],
        statuses: [],
        members: [],
        fab: false,
        loading: false
      }
    },

    mounted () {
      EventBus.$on('ticket-created', (payload) => { this.newTicket = false })
      EventBus.$on('board-created', (payload) => {
        this.newBoard = false
        if (payload) {
          this.boards.push(payload)
        }
      })

      this.loadProject()
    },

    computed: {
      logoThumbUrl () {
        if (this.project.links && this.project.links.logo_thumb_uri) {
          return (process.env.API_URL + this.project.links.logo_thumb_uri)
        }
        return null
      },

      stickyClass () {
        if (window.innerWidth > 599) {
          if (this.scroll > 0) {
            return 'elevation-8'
          } else {
            return ''
          }
        }
      }
    },

    methods: {
      loadProject () {
        this.loading = true

        projectService.show(
          async (data) => {
            this.project = Object.assign({}, data)
            document.title = `${this.project.attributes.name} - All tickets`
            EventBus.$emit('project-context', data.id)
            await Promise.all([this.loadBoards(), this.loadStatuses(), this.loadMembers()])
            this.loading = false
          },
          (err) => {
            console.log(err)
          },
          this.id
        )
      },

      loadBoards () {
        return boardService.projectIndex(
          (data) => {
            // sort the boards by name (considder sorting by date ?)
            this.boards = data.filter(brd => !brd.attributes.archived)
            this.boards.sort((a, b) => { return a.attributes.name.toLowerCase().localeCompare(b.attributes.name.toLowerCase()) })
          },
          (err) => {
            console.log(err)
          },
          this.project.id
        )
      },

      loadStatuses () {
        return statusService.projectIndex(
          (data) => {
            this.statuses = data.sort((a, b) => { return parseInt(a.position) - parseInt(b.position) })
          },
          (err) => {
            console.log(err)
          },
          this.project.id
        )
      },

      loadMembers () {
        return memberService.projectIndex(
          (data) => {
            this.members = data.filter(m => !m.attributes.discarded_at).sort((a, b) => { return a.attributes.name.toLowerCase().localeCompare(b.attributes.name.toLowerCase()) })
          },
          (err) => {
            console.log(err)
          },
          this.project.id
        )
      }
    }
  }
</script>

<style lang="scss" scoped>
  /* for some reason vuetify speed dials dont position the same way as naken fabs, so we have to force the issue*/
  .v-speed-dial {
    bottom: 96px;
    right: 72px;

    .v-speed-dial__list .v-tooltip {
      display: block;
      margin: 0 auto;
    }
  }

  @media screen and (min-width: 600px) {
    .sticky-element{
      position: sticky;
      position: -webkit-sticky;
      top: 65px;
      z-index: 5;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/project/show.vue